import images from "@/assets/images";
import PrismaticBurst from "@/components/PrismaticBurst";
import React from "react";

interface IBgProps {
  isLive: boolean;
}
const Bg: React.FC<IBgProps> = ({ isLive }) => {
  const [offset, setOffset] = React.useState({ x: 0, y: 0, isDone: false });
  React.useLayoutEffect(() => {
    if (isLive) {
      // 确保图片加载完成再进行获取内容 id为live-app-product-image
      const imageElement = document.getElementById("live-app-product-image") as HTMLImageElement;

      // 定义获取中心点位置的函数
      const getCenterPosition = () => {
        if (imageElement) {
          const rect = imageElement.getBoundingClientRect();
          const centerX = rect.left + rect.width / 2;
          const centerY = rect.top + rect.height / 2;

          // 计算相对于视口中心的偏移
          const viewportWidth = window.innerWidth;
          const viewportHeight = window.innerHeight;
          const offsetX = centerX - viewportWidth / 2;
          const offsetY = centerY - viewportHeight / 2;
          setOffset({ x: offsetX, y: -offsetY, isDone: true }); // 注意y轴方向相反
        }
      };

      if (imageElement) {
        // 检查图片是否已经加载完成
        if (imageElement.complete) {
          // 图片已加载完成，直接获取中心点位置
          getCenterPosition();
        } else {
          // 图片未加载完成，添加加载事件监听器
          imageElement.onload = () => {
            getCenterPosition();
          };
        }
      }
    }
  }, [isLive]);

  if (isLive) {
    if (!offset.isDone) return null;
    return (
      <div className="bg-animation absolute left-0 top-0 h-full w-full">
        <PrismaticBurst
          key={`prismatic`}
          animationType="rotate3d"
          intensity={0.9}
          speed={0.1}
          distort={0}
          rayCount={0}
          offset={{ x: offset.x, y: offset.y }} // 使用计算出的元素中心点坐标
          colors={["#FFD736", "#111214", "#111214"]}
        />
      </div>
    );
  }

  return (
    <div
      key={`bg`}
      className="bg-animation absolute left-0 top-0 h-full w-full bg-no-repeat"
      style={{
        backgroundImage: `url(${images.bg})`,
        backgroundSize: "100% 100%",
      }}
    ></div>
  );
};

export default Bg;
